export default __webpack_public_path__ + "static/media/google_grey.fcfc9eff.svg";